import { css } from '@emotion/react';
import { White } from '@constants/color';
import sickBabyBackground from '@assets/images/sick_baby_background.png';

export const container = css({
  width: 1920,
  height: 1080,
  display: 'flex',
  color: White.White10,
  backgroundImage: `url(${sickBabyBackground})`
});
